import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-pending-user',
  templateUrl: './modal-pending-user.component.html',
  styleUrls: ['./modal-pending-user.component.scss']
})
export class ModalPendingUserComponent {
  @Input() modalType: string = '';
  @Input() maxReasonLength: number = 250;
  @Output() successAction = new EventEmitter();
  @Output() cancelAction = new EventEmitter();
  @ViewChild('pendingJustification')
  pendingJustification!: ElementRef
  displayErrorMsgBlock: boolean = false;
  currentLength: number = 0;
  constructor(
    public activeModal: NgbActiveModal
  ) { }

  confirmUserPendingAction() {
    const pendingJustification = this.pendingJustification.nativeElement.value.trim();
    this.currentLength = pendingJustification.length;

    if (!pendingJustification) {
      this.displayErrorMsgBlock = true;
      return;
    }

    this.displayErrorMsgBlock = false;
    this.successAction.emit(pendingJustification);
    this.activeModal.close('Success');
    return;
  }

  cancelUserPendingAction() {
    this.cancelAction.emit();
    this.activeModal.close('Cancel');
  }

}
